'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime-corejs3/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime-corejs3/regenerator');
var _reduceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/reduce');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var request = require('../request.js');
var version = require('../version.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _reduceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_reduceInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);

var paramsSerializer = function paramsSerializer(params) {
  var _context;
  return _reduceInstanceProperty__default["default"](_context = _Object$keys__default["default"](params)).call(_context, function (res, key) {
    var _context4;
    var paramsValue = params[key];
    var paramValueString;
    if (_Array$isArray__default["default"](paramsValue)) {
      paramValueString = _mapInstanceProperty__default["default"](paramsValue).call(paramsValue, function (val) {
        var _context2;
        return _concatInstanceProperty__default["default"](_context2 = "".concat(key, "=")).call(_context2, val);
      }).join('&');
    } else if (typeof paramsValue === 'string') {
      var _context3;
      paramValueString = _concatInstanceProperty__default["default"](_context3 = "".concat(key, "=")).call(_context3, paramsValue);
    }
    return _filterInstanceProperty__default["default"](_context4 = [res, paramValueString]).call(_context4, Boolean).join('&');
  }, '');
};
var revokePrivileges = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(_ref) {
    var graph, roleName, privileges, vertexName, edgeName, attrName, queryName, res, _res;
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          graph = _ref.graph, roleName = _ref.roleName, privileges = _ref.privileges, vertexName = _ref.vertexName, edgeName = _ref.edgeName, attrName = _ref.attrName, queryName = _ref.queryName;
          _context5.next = 3;
          return version.getVersionIsGTE410();
        case 3:
          if (!_context5.sent) {
            _context5.next = 10;
            break;
          }
          _context5.next = 6;
          return request.getAxiosInstance().post('/api/gsql-server/gsql/v1/privileges/revoke', {
            vertexName: vertexName ? [vertexName] : undefined,
            edgeName: edgeName ? [edgeName] : undefined,
            attrNames: attrName ? [attrName] : undefined,
            queryName: queryName ? [queryName] : undefined,
            privileges: privileges,
            roles: [roleName]
          }, {
            params: {
              graph: graph
            },
            paramsSerializer: paramsSerializer
          });
        case 6:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 10:
          _context5.next = 12;
          return request.getAxiosInstance()["delete"]('/api/gsql-server/gsql/role', {
            params: {
              vertexName: vertexName,
              edgeName: edgeName,
              attrNames: attrName,
              privilege: privileges,
              role: roleName,
              graph: graph
            },
            paramsSerializer: paramsSerializer
          });
        case 12:
          _res = _context5.sent;
          return _context5.abrupt("return", _res);
        case 14:
        case "end":
          return _context5.stop();
      }
    }, _callee);
  }));
  return function revokePrivileges(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.revokePrivileges = revokePrivileges;
